<template>
    <b-form-group>
        <label class="mb-1 text-lg d-flex align-items-center">
            Tên người dùng
        </label>
        <b-input v-model="entry.name" type="text" placeholder="Nhập tên người dùng..." />
    </b-form-group>
</template>

<script>
export default {
    props: {
        value: Object,
    },
    data: () => ({
        entry: {
            name: "",
        },
    }),
    watch: {
        "entry.name": {
            handler: function () {
                this.$emit("update", {
                    ...this.value,
                    name: this.entry.name,
                });
            },
            deep: true,
        },
        "value.name": {
            handler: function () {
                this.entry.name = this.value.name;
            },
            deep: true,
        },
    },
    created() {
        this.entry = this.value;
    },
};
</script>